import { FC } from 'react';
import { Box } from '@rebass/emotion';
import { FormattedMessage } from 'react-intl';

import PageTitle from '@app/components/PageTitle';

import {
  Skeleton,
  SubHeader,
  SubHeaderTitle,
} from '@app/shop/components/Skeleton/Skeleton';
import messages from './NotFound.messages';

const NotFoundLayout: FC = ({ children }) => {
  return (
    <Skeleton>
      <PageTitle>{messages.title}</PageTitle>
      <SubHeader>
        <SubHeaderTitle>
          <FormattedMessage {...messages.title} />
        </SubHeaderTitle>
      </SubHeader>
      <Box>{children}</Box>
    </Skeleton>
  );
};

export default NotFoundLayout;
